import script from "./MyPayStubsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPayStubsPage.vue?vue&type=script&setup=true&lang=js"

import "./MyPayStubsPage.vue?vue&type=style&index=0&id=08ec42a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ec42a0"]])

export default __exports__